export const StartOfWeekOption = {
  SUNDAY: "Sunday",
  MONDAY: "Monday",
} as const;
export type StartOfWeekOption = (typeof StartOfWeekOption)[keyof typeof StartOfWeekOption];

export const TimeFormatOption = {
  HOUR12: "12-hour",
  HOUR24: "24-hour",
} as const;
export type TimeFormatOption = (typeof TimeFormatOption)[keyof typeof TimeFormatOption];

export const DefaultDurationOption = {
  MIN15: "15",
  MIN30: "30",
  MIN60: "60",
} as const;
export type DefaultDurationOption =
  (typeof DefaultDurationOption)[keyof typeof DefaultDurationOption];

export const VisibilityOption = {
  PUBLIC: "public",
  DEEPWORK: "deepwork",
  INVISIBLE: "invisible",
} as const;
export type VisibilityOption = (typeof VisibilityOption)[keyof typeof VisibilityOption];

export type OptionType =
  | StartOfWeekOption
  | TimeFormatOption
  | DefaultDurationOption
  | VisibilityOption;
